import { useMutation } from '@tanstack/react-query';

import { DisableRealTimeStatsData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const disableRealTimeStats = (data: DisableRealTimeStatsData): Promise<void> => {
  return axios.post(`/${PLATFORM_URL_SEGMENT[data.platform]}/pages/disable-realtime-stats`, data);
};

type DisableRealTimeStatsOptions = {
  config?: MutationConfig<typeof disableRealTimeStats>;
};

export function useDisableRealTimeStats({ config }: DisableRealTimeStatsOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: disableRealTimeStats,
  });
}
